import { useState } from "react";
import { SITE_ROUTES, SITE_ROUTE_GROUPS, previewPathFor } from "../../config/site-routes";
import { SeoPanel } from "../../components/Editor/SeoPanel";
import { LangToggle, type Lang } from "../../components/Editor/LangToggle";
import { cn } from "@/lib/utils";

export default function PagesSeo() {
  const [selectedPath, setSelectedPath] = useState<string>(SITE_ROUTES[0].path);
  const [lang, setLang] = useState<Lang>("tr");

  const selectedRoute = SITE_ROUTES.find((r) => r.path === selectedPath) ?? SITE_ROUTES[0];

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Sayfalar & SEO</h1>

      <div className="flex gap-6 items-start">
        {/* Left: route list */}
        <div className="w-64 shrink-0">
          <div className="rounded-md border overflow-hidden">
            {SITE_ROUTE_GROUPS.map((group) => (
              <div key={group.titleTr}>
                <div className="px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground bg-muted/40 border-b">
                  {group.titleTr}
                </div>
                {group.routes.map((route) => (
                  <button
                    key={route.path}
                    type="button"
                    onClick={() => setSelectedPath(route.path)}
                    className={cn(
                      "w-full text-left px-3 py-2.5 text-sm border-b last:border-b-0 transition-colors",
                      route.parentTr && "pl-6",
                      selectedPath === route.path
                        ? "bg-primary text-primary-foreground font-medium"
                        : "hover:bg-muted/60 text-foreground",
                    )}
                  >
                    <div className="font-medium truncate">
                      {route.parentTr && (
                        <span
                          className={cn(
                            "font-normal",
                            selectedPath === route.path
                              ? "text-primary-foreground/70"
                              : "text-muted-foreground",
                          )}
                        >
                          {route.parentTr} ›{" "}
                        </span>
                      )}
                      {route.labelTr}
                    </div>
                    <div
                      className={cn(
                        "text-[11px] truncate mt-0.5",
                        selectedPath === route.path
                          ? "text-primary-foreground/70"
                          : "text-muted-foreground",
                      )}
                    >
                      {route.path}
                    </div>
                  </button>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Right: SEO panel for selected route */}
        <div className="flex-1 min-w-0">
          <div className="rounded-md border p-5 space-y-4">
            {/* Header */}
            <div className="space-y-1">
              <h2 className="text-base font-semibold">
                {selectedRoute.labelTr} / {selectedRoute.labelEn}
              </h2>
              <p className="text-xs text-muted-foreground">
                Bu sayfanın TR/EN SEO ayarları —{" "}
                <code className="bg-muted px-1 py-0.5 rounded text-[11px]">{selectedPath}</code>
              </p>
            </div>

            {/* Lang toggle */}
            <div className="flex items-center gap-3">
              <span className="text-sm text-muted-foreground">Dil:</span>
              <LangToggle value={lang} onChange={setLang} />
            </div>

            {/* SEO panel — re-mounts when path or lang changes to reset form */}
            <SeoPanel
              key={`${selectedPath}-${lang}`}
              path={selectedPath}
              previewPath={previewPathFor(selectedPath, lang)}
              locale={lang}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
